import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mark } from "@/components/Logo";
import { api } from "@/lib/api";

const COLS = [
  {
    title: "RUN",
    links: [
      ["Find a Club", "/clubs"],
      ["Ranked: Best of 2026", "/ranked"],
      ["Dallas Hub", "/dallas"],
      ["Events", "/events"],
      ["Join the Club", "/join"],
    ],
  },
  {
    title: "TRAIN",
    links: [
      ["Training Hub", "/training"],
      ["Tools & Calculators", "/tools"],
      ["Plan Builder", "/plan"],
      ["HYROX", "/training/category/hyrox"],
      ["Start Running", "/training/category/start-running"],
    ],
  },
  {
    title: "CLUB",
    links: [
      ["Stories", "/stories"],
      ["Collabs", "/collabs"],
      ["Shop", "/shop"],
      ["Submit a Club", "/submit"],
      ["About", "/about"],
    ],
  },
  {
    title: "SHOP",
    links: [
      ["City Series", "/shop/city-series"],
      ["Running Shirts", "/shop/running-shirts"],
      ["Running Hats", "/shop/running-hats"],
      ["Shipping", "/shipping"],
      ["Returns", "/returns"],
      ["Size Guide", "/size-guide"],
      ["Order Lookup", "/order-lookup"],
    ],
  },
];

export const Footer = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <footer className="bg-ink border-t border-white/10" data-testid="site-footer">
      <div className="px-5 lg:px-10 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3 text-white">
              <Mark white className="h-11 w-12" />
              <span className="font-display text-3xl">NINJA RUN CLUB</span>
            </div>
            <p className="font-display text-white/40 text-xl mt-6">BETTER WITH EVERY MILE.</p>
            <p className="font-mono-label text-white/30 mt-3">DALLAS BORN. RUNNING EVERYWHERE.</p>
            {stats && (
              <p data-testid="footer-proof-bar" className="font-mono-label text-white/50 mt-6 border border-white/15 px-4 py-3 inline-block">
                {stats.clubs} CLUBS · {stats.cities} CITIES · {stats.articles} FREE GUIDES · HUMAN-VERIFIED
              </p>
            )}
          </div>
          {COLS.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <p className="font-mono-label text-white/40 mb-5">{col.title}</p>
              <ul className="space-y-3">
                {col.links.map(([label, to]) => (
                  <li key={label}>
                    <Link to={to} className="text-white/70 hover:text-white text-sm link-underline transition-colors duration-200">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-16 pt-10 border-t border-white/10" data-testid="footer-family-module">
          <p className="font-display text-2xl text-white">THREE HOUSES. ONE CODE.</p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10 mt-6">
            <div className="bg-ink p-6" data-testid="family-house-nrc">
              <p className="font-mono-label text-white/80">NINJA RUN CLUB</p>
              <p className="text-white/50 text-sm mt-2">Run clubs, training, and race prep. The house you are in.</p>
              <p className="font-mono-label text-white/30 mt-4">YOU ARE HERE</p>
            </div>
            <a
              href="https://ninjathlete.com"
              target="_blank"
              rel="noopener"
              data-testid="family-house-ninjathlete"
              className="group bg-ink p-6 hover:bg-white transition-colors duration-300"
            >
              <p className="font-mono-label text-white/80 group-hover:text-ink">NINJATHLETE</p>
              <p className="text-white/50 group-hover:text-ink/60 text-sm mt-2">Supplements, gear, and recovery science for hybrid athletes.</p>
              <p className="font-mono-label text-white/30 group-hover:text-ink/50 mt-4">NINJATHLETE.COM →</p>
            </a>
            <a
              href="https://ninjathleticlub.com"
              target="_blank"
              rel="noopener"
              data-testid="family-house-ninjathleticlub"
              className="group bg-ink p-6 hover:bg-white transition-colors duration-300"
            >
              <p className="font-mono-label text-white/80 group-hover:text-ink">NINJA ATHLETIC CLUB</p>
              <p className="text-white/50 group-hover:text-ink/60 text-sm mt-2">Mindset, discipline, and the art of showing up.</p>
              <p className="font-mono-label text-white/30 group-hover:text-ink/50 mt-4">NINJATHLETICLUB.COM →</p>
            </a>
          </div>
        </div>
        <div className="mt-10 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4">
          <p className="font-mono-label text-white/30">© {new Date().getFullYear()} NINJA RUN CLUB · NINJARUNCLUB.COM</p>
          <nav aria-label="Legal" className="flex gap-5">
            {[["CONTACT", "/contact"], ["PRIVACY", "/privacy"], ["TERMS", "/terms"]].map(([label, to]) => (
              <Link key={to} to={to} className="font-mono-label text-white/30 hover:text-white transition-colors duration-200">{label}</Link>
            ))}
          </nav>
          <p className="font-mono-label text-white/30">WE DO NOT RUN ALONE.</p>
        </div>
      </div>
    </footer>
  );
};
